export default __webpack_public_path__ + "img/150DW.47b214e89b970a056ecb09b7ecf00db5.jpg";